import React from 'react';
export const Story = () => {
  return <div className="py-8" data-id="element-223">
      <div className="prose max-w-none" data-id="element-224">
        <div className="mb-6" data-id="element-225">
          <p className="text-sm uppercase tracking-wider text-gray-600" data-id="element-226">
            5e september 2025 | Personlig berättelse | Av Sofia Bergström
          </p>
          <h1 className="text-4xl font-bold mb-4 text-green-700" data-id="element-227">
            Min kamp med vikten - en historia många känner igen
          </h1>
          <h2 className="text-xl text-gray-700 mb-6" data-id="element-228">
            Efter år av kamp med olika dieter hittade jag äntligen något som
            fungerade för både mig och mina föräldrar
          </h2>
        </div>
        <div className="float-right ml-6 mb-4 md:w-1/3 w-full" data-id="element-229">
          <div className="bg-green-50 p-4 rounded-lg border border-green-100 text-center" data-id="element-230">
            <p className="italic text-gray-600 mb-2" data-id="element-231">
              "Efter flera år av frustration och besvikelse hade jag nästan gett
              upp hoppet om att någonsin hitta balans med min vikt."
            </p>
            <div className="w-16 h-1 bg-green-200 mx-auto" data-id="element-232"></div>
          </div>
        </div>
        <p className="text-lg mb-4" data-id="element-233">
          Hej alla mina kära läsare! Sofia här. Jag har funderat länge på om jag
          skulle dela denna berättelse, eftersom den är så personlig, men jag
          vet att många av er kämpar med samma saker som jag har gjort. Så här
          kommer den - min fullständiga historia om hur jag äntligen hittade ett
          sätt att må bra i min kropp.
        </p>
        <p className="text-lg mb-4" data-id="element-234">
          Som många av er vet (om ni följt bloggen ett tag) har jag alltid haft
          en komplicerad relation till min vikt. Ända sedan tonåren har jag
          kämpat med att hålla min vikt stabil, och jag har provat nästan alla
          dieter du kan tänka dig - LCHF, 5:2, periodisk fasta, raw food...
          listan kan göras lång.
        </p>
        <p className="text-lg mb-4" data-id="element-235">
          Varje gång var mönstret detsamma: initialt tappade jag några kilon,
          kände mig motiverad, men efter några veckor kom sötsuget tillbaka med
          full kraft. Min energi sjönk, och jag kände mig irriterad och
          nedstämd. Så småningom gav jag upp, och vikten kom tillbaka - ofta med
          några extra kilon som bonus.
        </p>
        <div className="my-8 flex justify-center" data-id="element-236">
          <div className="relative w-2/3 md:w-1/2" data-id="element-237">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sMdaHRFhspMz9EG99LdJ18/75b8fffd-5880-4e15-b68f-5421cb8d3e9a_min.webp?story=before&t=1" alt="Sofia innan förändringen" className="w-full h-auto rounded-lg shadow-md filter grayscale" loading="eager" fetchpriority="high" onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = 'https://uploadthingy.s3.us-west-1.amazonaws.com/sMdaHRFhspMz9EG99LdJ18/75b8fffd-5880-4e15-b68f-5421cb8d3e9a_min.webp';
          }} data-id="element-238" />
            <div className="absolute top-0 left-0 bg-red-500 text-white py-1 px-3 rounded-br-lg rounded-tl-lg font-bold" data-id="element-239">
              FÖRE
            </div>
          </div>
        </div>
        <p className="mt-2 text-center italic" data-id="element-240">
          En selfie jag tog i bilen efter ännu ett misslyckat dietförsök - jag
          var så trött på att kämpa
        </p>
        <p className="text-lg mb-4" data-id="element-241">
          Det värsta var inte ens vikten i sig, utan hur den påverkade mitt
          humör och min energi. Jag kände mig konstant trött, hade svårt att
          fokusera på jobbet och ville bara komma hem och krascha i soffan på
          kvällarna. Mina vänner ville ut och göra saker, men jag orkade inte.
          Jag kände mig fast i en ond cirkel.
        </p>
        <p className="text-lg mb-4" data-id="element-242">
          Min syster Lisa brukade skämta om att hon kunde avgöra vilken diet jag
          testade baserat på mitt humör. "Åh, du måste vara på LCHF nu, för du
          blir alltid irriterad dag tre", eller "Periodisk fasta igen? Då ses vi
          inte förrän om två veckor när du ger upp." Det var menat som skämt,
          men det fanns en sanning i det som gjorde ont.
        </p>
        <p className="text-lg mb-4" data-id="element-243">
          Viktproblem var tyvärr något som gick i familjen. Min mamma har kämpat
          med sin vikt i stort sett hela sitt vuxna liv, och efter menopausen
          blev det ännu svårare för henne. Hon brukade säga att "när man blir
          äldre blir kroppen mer envis - den vill behåla allt den har". Jag såg
          hur hon testade diet efter diet utan bestående resultat, och hur det
          påverkade både hennes fysiska hälsa och självkänsla.
        </p>
        <p className="text-lg mb-4" data-id="element-244">
          Pappa hade också börjat få problem med vikten när han passerade 50,
          och fick högt blodtryck som följd. Läkaren hade varit tydlig: "Gå ner
          i vikt eller börja med mediciner resten av livet." Det skrämde mig att
          se mina föräldrar kämpa så, särskilt eftersom jag visste att det blir
          ännu svårare att gå ner i vikt ju äldre man blir. Metabolismen saktar
          ner, hormonerna förändras, och för kvinnor blir det extra utmanande
          efter övergångsåldern.
        </p>
        <h3 className="text-2xl font-semibold mt-8 mb-4 text-green-700" data-id="element-245">
          När jag nästan hade gett upp hoppet...
        </h3>
        <p className="text-lg mb-4" data-id="element-246">
          Efter min 24-årsdag i januari bestämde jag mig för att sluta med
          dieter helt och hållet. Jag var så trött på besvikelsen, på att känna
          mig misslyckad, på att ständigt prata om vikt och mat. Jag ville
          fokusera på andra saker i livet och acceptera min kropp som den var.
        </p>
        <div className="flex flex-col md:flex-row gap-6 my-8 items-center" data-id="element-247">
          <div className="md:w-1/2" data-id="element-248">
            <p className="text-lg mb-4" data-id="element-249">
              Det var just då, när jag mentalt hade gett upp jakten på den
              "perfekta kroppen", som jag stötte på något som skulle förändra
              allt. Ibland kommer de största upptäckterna när man minst anar
              det.
            </p>
            <p className="text-lg mb-4" data-id="element-250">
              Jag hade bestämt mig för att fokusera på mitt välmående istället
              för vikten. Jag ville hitta energi för att kunna leva det liv jag
              drömde om - att orka med både jobb, vänner och fritidsintressen
              utan att känna mig helt slutkörd.
            </p>
          </div>
          <div className="md:w-1/2" data-id="element-251">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1oCNQjNCdNVe1TefKviqoi/soffasad.png?tired=true&t=1" alt="Trött kvinna på soffan" className="w-full h-auto rounded-lg shadow-md" loading="eager" fetchpriority="high" onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = 'https://uploadthingy.s3.us-west-1.amazonaws.com/1oCNQjNCdNVe1TefKviqoi/soffasad.png';
          }} data-id="element-252" />
            <p className="mt-2 text-center italic" data-id="element-253">
              Så här kände jag mig dagligen - trött, utan energi och motivation
            </p>
          </div>
        </div>
        <p className="text-lg mb-4" data-id="element-254">
          En kväll när jag scrollade genom Instagram såg jag ett inlägg från en
          tjej som verkade ha haft exakt samma problem som jag. Hon berättade om
          ett kosttillskott som hette Nourix, som hade hjälpt henne att komma ur
          sin viktcykel. Normalt skulle jag ha scrollat vidare - jag var så
          trött på mirakelkurer - men något med hennes berättelse kändes äkta.
        </p>
        <p className="text-lg mb-4" data-id="element-255">
          Efter att ha läst mer om Nourix blev jag intresserad. Det var inte en
          klassisk diet eller ett snabbt fix, utan ett naturligt tillskott som
          arbetade med kroppen för att balansera hormoner, stödja
          ämnesomsättningen och minska sötsuget. Det lät för bra för att vara
          sant, men jag bestämde mig för att ge det en chans.
        </p>
        <div className="my-8 flex justify-center" data-id="element-256">
          <div className="w-full md:w-2/3" data-id="element-257">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dxWD6YGpE53U8vf2DT3d2n/dasdasda.png?nourix=package&t=1" alt="Nourix-förpackningen" className="w-full h-auto max-h-[400px] rounded-lg shadow-md object-contain bg-white" loading="eager" fetchpriority="high" onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = 'https://uploadthingy.s3.us-west-1.amazonaws.com/dxWD6YGpE53U8vf2DT3d2n/dasdasda.png';
          }} data-id="element-258" />
            <p className="mt-3 text-center italic" data-id="element-259">
              Nourix - den lilla kapseln som förändrade allt för mig
            </p>
          </div>
        </div>
        <p className="text-lg mb-4" data-id="element-260">
          Det som övertygade mig var att Nourix fokuserade på rotorsakerna till
          viktproblem - hormonell obalans, inflammation och insulinresistens -
          snarare än att bara försöka tvinga ner vikten med extrema metoder.
          Dessutom innehöll det bara naturliga ingredienser, vilket var viktigt
          för mig eftersom jag tidigare fått biverkningar av syntetiska
          viktminskningsprodukter.
        </p>
        <p className="text-lg mb-4" data-id="element-261">
          Jag tänkte också på mina föräldrar när jag läste om Nourix. Om det
          kunde hjälpa mig, kanske det också kunde hjälpa dem? Särskilt mamma
          som kämpade så med sin vikt efter menopausen, när hormonerna
          förändrades och gjorde viktminskning nästan omöjlig. Produkten verkade
          ju fokusera just på hormonell balans, vilket lät lovande för någon i
          hennes situation.
        </p>
        <p className="text-lg mb-4" data-id="element-262">
          Jag minns hur skeptisk jag var när jag beställde min första
          förpackning. Jag berättade inte ens för mina vänner eller min syster,
          eftersom jag var så trött på att prata om nya viktminskningsförsök som
          ändå skulle misslyckas. Jag tänkte att om det inte fungerade, behövde
          ingen veta att jag hade försökt igen.
        </p>
      </div>
    </div>;
};